import React from 'react';
import { Button, Avatar, Icon } from '@socialchorus/shared-ui-components';
import { ExternalCard } from '../../../models/chatbot/types';

interface ExternalRefCardProps {
  card: ExternalCard;
}

const ExternalRefCard: React.FC<ExternalRefCardProps> = ({ card }) => {
  const url =
    card.action.type === 'navigation' ? card.action.navigation.url : '';

  return (
    <Button
      variant="link"
      href={url}
      title={card.heading}
      className="chatbot__reference-card chatbot__reference-card--external"
      target="_blank"
      rel="noopener noreferrer"
      asChild
    >
      <div className="chatbot__reference-card-content">
        <div className="chatbot__reference-card-body">
          <div
            className={`chatbot__reference-avatar${
              card.icon ? ' chatbot__reference-avatar--thumbnail' : ''
            }`}
          >
            {card.icon ? (
              <Avatar imgSrc={card.icon} size="medium" shape="square" alt="" />
            ) : (
              <Icon size={24}>language</Icon>
            )}
            {card.sourceIcon && (
              <div className="chatbot__reference-source-overlay">
                <img src={card.sourceIcon} alt="" />
              </div>
            )}
          </div>
          <div className="chatbot__reference-text">
            <h4 className="chatbot__reference-title">{card.heading}</h4>
            {card.subheading && (
              <p className="chatbot__reference-description">
                {card.subheading}
              </p>
            )}
          </div>
        </div>
      </div>
    </Button>
  );
};

export default ExternalRefCard;
